import React from "react";

export default function CardDireksi ({foto, nama, jabatan, deskripsi}) {

    return (
        <div className="card-tentang-kami">
            <img className="img-back" src={require(`../../../assets/img/tentang-kami/${foto}.png`)} alt='direksiImage'></img>
            <div className="text-section-direksi">
                <h5>{nama}</h5>
                <p style={{color:"#707070", fontWeight:"500"}}>{jabatan}</p>
                <p><div dangerouslySetInnerHTML={{__html: deskripsi}} style={{lineHeight:"1.5"}}/></p>
            </div>
        </div>
    );
}